export default function VisualizableFacet({
  handleFilterVisualizable,
  productVisualizables,
  selectedVisualizable,
}) {
  const visualizableVal = selectedVisualizable == "Yes" ? "" : "Yes";
  const visualizableClass =
    selectedVisualizable == "Yes"
      ? "visualizableActive"
      : "visualizableInactive";
  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("visualizable") &&
    plpFacetLabel.visualizable != ""
      ? plpFacetLabel.visualizable
      : "Visualizable";
  return (
    <div class="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        <div
          className={`visualizableIcon ${visualizableClass}`}
          id={`visualizable-filter`}
          data-value={visualizableVal}
          onClick={(e) =>
            handleFilterVisualizable("visualizable", e.target.dataset.value)
          }>
          <span className="visualizablePoint"></span>
        </div>
        {`Yes (${
          productVisualizables["Yes"] ? productVisualizables["Yes"] : 0
        })`}
      </div>
    </div>
  );
}
